import React from 'react'
import { LocationDescriptor, createPath } from 'history'
import { RenderResult } from '@deal/web-express-server'

export type ResponseContextType =
  | {
      redirect: (url: LocationDescriptor, statusCode?: number) => void
    }
  | undefined

interface ResponseProviderProps {
  responseContext: RenderResult['context']
}

const ResponseContext = React.createContext<ResponseContextType>(undefined)

const ResponseConsumer = ResponseContext.Consumer

class ResponseProvider extends React.Component<ResponseProviderProps> {
  constructor(props: ResponseProviderProps) {
    super(props)

    this.handleMutateContext = this.handleMutateContext.bind(this)
  }

  public handleMutateContext(redirectUrl: LocationDescriptor, statusCode?: number) {
    const finalRedirectUrl = typeof redirectUrl === 'string' ? redirectUrl : createPath(redirectUrl)

    this.props.responseContext.statusCode = statusCode
    this.props.responseContext.url = finalRedirectUrl
  }

  public render() {
    const { children } = this.props

    return (
      <ResponseContext.Provider value={{ redirect: this.handleMutateContext }}>
        {children}
      </ResponseContext.Provider>
    )
  }
}

export { ResponseConsumer, ResponseProvider }
